<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SelectCountry" });
import { AutocompleteSingle } from "../../../../selects/index.js";
import { COUNTRIES } from "../../config/country-codes.js";
import { COUNTRY_CODE } from "../../../../common/environment.js";
import { SESSION_ORGANIZATION } from "../../../authentication/index.js";
import { t } from "svelte-i18n";
export let key = $SESSION_ORGANIZATION?.domain === "internal" ? void 0 : COUNTRY_CODE;
export let label = "resource.address.properties.country.label";
export let isDisabled = false;
export let isRequired = true;
$: options = COUNTRIES.map((option) => ({ ...option, label: $t(option.label) })).sort((optionA, optionB) => optionA.label.localeCompare(optionB.label));
</script>

<AutocompleteSingle
    bind:key
    name = 'address.countryCode'
    placeholder = 'resource.address.properties.country.placeholder'
    { options }
    { label }
    { isDisabled }
    { isRequired }
/>